// Mock Data for Respiratory Diseases Category

const baseProducts = [
    {
        id: "med-resp-1",
        name: "Budesonide/Formoterol",
        genericName: "Brand: Symbicort",
        indication: "Asthma/COPD",
        price: "$52",
        originalPrice: "$428",
        savings: "88%",
        description: "A combination medication used to manage and prevent symptoms of asthma and chronic obstructive pulmonary disease (COPD). It contains a steroid to reduce inflammation and a bronchodilator to open airways.",
        dosage: "Typically inhaled twice daily. Follow physician instructions.",
        packaging: "1 Inhaler (120 Doses)",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature away from heat and moisture.",
        sideEffects: "Headache, throat irritation, or thrush. Rinse mouth after use.",
        category: "Inhaled Corticosteroids / LABA"
    },
    {
        id: "med-resp-2",
        name: "Tiotropium 18mcg",
        genericName: "Brand: Spiriva",
        indication: "COPD",
        price: "$34",
        originalPrice: "$488",
        savings: "93%",
        description: "A long-acting bronchodilator used to control and prevent symptoms like wheezing, shortness of breath, and coughing caused by ongoing lung diseases such as COPD.",
        dosage: "Inhale the contents of one capsule once daily using the provided device.",
        packaging: "Contains 30 Capsules + Inhaler Device",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store below 25°C. Do not expose capsules to extreme temperatures.",
        sideEffects: "Dry mouth, constipation, or mild throat irritation.",
        category: "Long-Acting Anticholinergics"
    },
    {
        id: "med-resp-3",
        name: "Montelukast 10mg",
        genericName: "Brand: Singulair",
        indication: "Asthma/Allergies",
        price: "$22",
        originalPrice: "$320",
        savings: "93%",
        description: "Used for the maintenance treatment of asthma and to relieve symptoms of seasonal allergies. It works by blocking leukotrienes to decrease swelling in the lungs.",
        dosage: "Taken orally once daily in the evening.",
        packaging: "Contains 30 Tablets",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store below 30°C in a dry place. Protect from light.",
        sideEffects: "Headache, stomach pain, or mild rash.",
        category: "Leukotriene Receptor Antagonists"
    },
    {
        id: "med-resp-4",
        name: "Fluticasone/Salmeterol",
        genericName: "Brand: Advair",
        indication: "Asthma/COPD",
        price: "$32",
        originalPrice: "$418",
        savings: "92%",
        description: "An inhaled corticosteroid and long-acting bronchodilator combination to manage asthma and COPD, improving lung function and reducing exacerbations.",
        dosage: "Inhaled twice a day. Read the complete instructions before use.",
        packaging: "1 Diskus device (60 blisters)",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature in a dry place.",
        sideEffects: "Hoarseness, throat irritation, or oral thrush. Rinse mouth after use.",
        category: "Inhaled Corticosteroids / LABA"
    },
    {
        id: "med-resp-5",
        name: "Ipratropium/Albuterol",
        genericName: "Brand: Combivent",
        indication: "COPD/Asthma",
        price: "$20",
        originalPrice: "$386",
        savings: "95%",
        description: "A short-acting combination inhaler used to prevent bronchospasm in people with COPD who are also using other medicines to control their condition.",
        dosage: "Typically one inhalation four times a day.",
        packaging: "1 Inhaler device",
        manufacturer: "Various Quality Indian Manufacturers",
        storage: "Store at room temperature. Keep away from extreme heat.",
        sideEffects: "Tremor, nervousness, or fast heart rate.",
        category: "Short-Acting Bronchodilators"
    }
];

const generateAlphabetMeds = () => {
    const meds = [];
    const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXY".split(""); // 25 letters
    let priceBase = 2000;
    let ourPriceBase = 180;
    let dosageCount = 100;

    alphabets.forEach((letter, index) => {
        const id = `med-resp-alpha-${index + 6}`;
        const name = `Medication ${letter} ${dosageCount}mg`;
        const originalPrice = priceBase;
        const price = ourPriceBase;
        const discount = Math.round(((originalPrice - price) / originalPrice) * 100);

        meds.push({
            id: id,
            name: name,
            genericName: `Medication Generic ${letter} ${dosageCount}mg`,
            indication: "Respiratory Diseases and Asthma Care",
            price: `$${price}`,
            originalPrice: `$${originalPrice.toLocaleString()}`,
            savings: `${discount}%`,
            description: `Quality generic medication for the treatment of respiratory conditions like Asthma and COPD. Sourced from WHO-GMP certified facilities ensuring efficacy and safety.`,
            dosage: "As prescribed by your pulmonologist.",
            packaging: "Contains 30 Tablets or 1 Inhaler",
            manufacturer: "Licensed Top Indian Manufacturer",
            storage: "Store below 25°C in a cool, dry place. Protect from light.",
            sideEffects: "Consult your doctor for specific side effects. May include dry mouth or mild headache.",
            category: "General Respiratory Care"
        });

        dosageCount += 25; // Increase dosage somewhat
        // Mix up prices slightly
        if (index % 3 === 0) {
            priceBase += 400;
            ourPriceBase += 30;
        } else if (index % 2 === 0) {
            priceBase -= 200;
            ourPriceBase -= 15;
        } else {
            priceBase += 600;
            ourPriceBase += 40;
        }
    });

    return meds;
};

// Combine the two sets of products
export const respiratoryProducts = [...baseProducts, ...generateAlphabetMeds()];

export const respiratoryHeroData = {
    title: "Respiratory Diseases",
    subtitle: "Asthma, COPD, and chronic respiratory condition management",
    description: "Access high-quality medications for the management of Asthma, Chronic Obstructive Pulmonary Disease (COPD), and other respiratory conditions. We supply carefully sourced, effective treatments from verified manufacturers.",
    stats: [
        { number: "30+", label: "Medications" },
        { number: "90%", label: "Average Savings" }
    ]
};

export const respiratoryCategories = [
    "All Categories",
    "Inhaled Corticosteroids / LABA",
    "Long-Acting Anticholinergics",
    "Leukotriene Receptor Antagonists",
    "Short-Acting Bronchodilators",
    "General Respiratory Care"
];

export const respiratoryTrustBadges = [
    { text: "WHO-GMP Certified Sources", icon: "ShieldCheck" },
    { text: "Secure Global Shipping", icon: "Plane" },
    { text: "Verified Pharmacists", icon: "Users" },
    { text: "Quality Guaranteed", icon: "Award" }
];

export const respiratoryFAQs = [
    {
        question: "Do you require a prescription for inhalers and asthma medications?",
        answer: "Yes, a valid prescription from a licensed physician or pulmonologist is required to place an order for respiratory medications."
    },
    {
        question: "Are these generic inhalers as effective as the brand-name versions?",
        answer: "Yes. The bioequivalence of our generic products ensures the exact same active pharmaceutical ingredients, delivery systems, and clinical results as the expensive brand names."
    },
    {
        question: "How do you ensure safe shipping for fragile inhaler devices?",
        answer: "All respiratory devices and inhalers are carefully packed in protective, impact-resistant packaging to guarantee they arrive in perfect condition."
    },
    {
        question: "Is international shipping available for life-saving respiratory drugs?",
        answer: "Yes, we ship globally using expedited courier services with tracking provided, ensuring your maintenance treatments are never delayed."
    }
];

export const respiratoryTestimonials = [
    {
        name: "Lisa K.",
        country: "United States",
        savings: "$3,800 annually",
        condition: "Severe Asthma",
        medication: "Budesonide/Formoterol",
        text: "My Symbicort equivalent costs a fraction of what I was paying in the US. The inhaler quality is excellent, and my asthma stays perfectly under control. Thank you."
    },
    {
        name: "James T.",
        country: "Australia",
        savings: "$4,100 annually",
        condition: "COPD",
        medication: "Tiotropium",
        text: "Managing COPD is tough, but the financial relief provided by MediSeller makes it much easier. The Spiriva generic is identical to what I used before."
    },
    {
        name: "Elena P.",
        country: "United Kingdom",
        savings: "$2,200 annually",
        condition: "Allergic Asthma",
        medication: "Montelukast",
        text: "Switching to the generic Singulair from this pharmacy has been straightforward. Customer service is brilliant and always keeps me informed."
    }
];

export const respiratorySectionContent = {
    testimonials: {
        title: "Patient Success Stories",
        description: "Hear from patients successfully managing their asthma and COPD through affordable access."
    },
    faqs: {
        title: "Frequently Asked Questions",
        description: "Important information about securing your respiratory medications."
    },
    midPageCTA: {
        title: "Can't Find Your Respiratory Medication?",
        description: "We have access to an extensive supply network. Our specialists can help source specific inhalers or respiratory drugs at up to 90% savings.",
        whatsappText: "Chat on WhatsApp",
        requestText: "Submit Custom Request"
    },
    finalCTA: {
        title: "Breathe Easier with Affordable Care",
        description: "Secure your high-quality asthma and COPD medications today with global home delivery.",
        whatsappText: "Start WhatsApp Chat",
        requestText: "Request Free Consultation"
    },
    adminFooter: {
        brandName: "MediSeller Global",
        copyrightYear: "2025",
        rightsText: "All rights reserved. | Licensed International Pharmacy"
    }
};
